var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ais-search-box',{scopedSlots:_vm._u([{key:"default",fn:function({ isSearchStalled, refine }){return [_c('m-search-field',{attrs:{"debounce":_vm.debounce,"loading":isSearchStalled,"value":_vm.query},on:{"input":function($event){return refine($event)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }